export default "__VITE_ASSET__DixKam_q__"